module.exports = __webpack_public_path__ + "static/img/light.2ed3c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light.png
// module id = dPD+
// module chunks = 7